/**
 * If enablePackageRates (default is false) is true for this module, then we show two subTabs under Hotel TAB: Standalone Rates vs Package Rates.
 * When the user is searching from the Standalone Rates everything is the same as the default use case search.
 * When the user is searching from the Package Rates, they need to accept the terms and conditions and that will
 * add this argument to the search URL `packageRates=true`. User can only search hotel in this tab,
 * there should be no car, flight or other filters/add-ons present on the Packager Rates subTab.
 * The difference between the subTabs contents is handled by `renderTabChildren` function prop;
 * This is managed by `wizard-hotel-pwa-v2` module (https://flexmanager.prod.expedia.com/#/moduleStore/show/255)
 */
import * as React from "react";
import { observer } from "mobx-react";
import { locKeys } from "components/flexComponents/WizardHotelPWA/components/l10n";
import { useLocalization } from "@shared-ui/localization-context";
import {
  UitkExperimentalButtonTabs,
  UitkTab,
  UitkTabAnchorType,
  UitkTabsType,
} from "uitk-react-experimental-button-tabs";
import { HotelRatesType } from "stores/wizard/state/typings";
import { UitkSpacing } from "uitk-react-spacing";

export interface HotelSubTabsProps {
  currentSubTab: string;
  onTabSelect: (hotelRateType: HotelRatesType) => void;
  renderTabChildren: (arg1: boolean, arg2: boolean) => React.ReactElement;
}

export const HotelSubTabs = observer(({ currentSubTab, onTabSelect, renderTabChildren }: HotelSubTabsProps) => {
  const { formatText } = useLocalization();
  const tabIdPrefix = "wizard-hotel-tab-";

  return (
    <UitkSpacing margin={{ blockstart: "three" }}>
      <UitkExperimentalButtonTabs
        className="flightTypeTabs"
        selectedTab={currentSubTab}
        onTabSelect={onTabSelect}
        tabsType={UitkTabsType.NATURAL}
        tabAnchorType={UitkTabAnchorType.BUTTON}
        data-testid={currentSubTab}
      >
        <UitkTab
          name={HotelRatesType.STANDALONE}
          displayName={formatText(locKeys.hotelStandaloneRates)}
          id={`${tabIdPrefix}${HotelRatesType.STANDALONE}`}
          key={`${tabIdPrefix}${HotelRatesType.STANDALONE}`}
        >
          {currentSubTab === HotelRatesType.STANDALONE && renderTabChildren(false, false)}
        </UitkTab>

        <UitkTab
          name={HotelRatesType.PACKAGE_RATES}
          displayName={formatText(locKeys.hotelPackageRates)}
          id={`${tabIdPrefix}${HotelRatesType.PACKAGE_RATES}`}
          key={`${tabIdPrefix}${HotelRatesType.PACKAGE_RATES}`}
        >
          {currentSubTab === HotelRatesType.PACKAGE_RATES && renderTabChildren(false, true)}
        </UitkTab>
      </UitkExperimentalButtonTabs>
    </UitkSpacing>
  );
});
